import React from 'react';
import Image from 'next/image';
import m1 from '../../assets/images/m1.png';
import m2 from '../../assets/images/m2.png';
import m3 from '../../assets/images/m3.png';
import m4 from '../../assets/images/m4.png';
import m5 from '../../assets/images/m5.png';
import m6 from '../../assets/images/m6.png';
import m7 from '../../assets/images/m7.png';
import styles from './eventhero.module.scss'

const EventHeroImage = () => {
  return (
    <div className={styles.eventheroimage}>
      <div>
        <Image
          src={m1}
          alt='m1'
          onLoadingComplete={(image) => image.classList.remove('opacity-0')}
          className='transition-opacity opacity-0 duration-[2s]'
        />
        <Image
          src={m2}
          alt='m2'
          onLoadingComplete={(image) => image.classList.remove('opacity-0')}
          className='transition-opacity opacity-0 duration-[2s]'
        />
      </div>

      <div>
        <div>
          <Image
            src={m3}
            alt='m3'
            onLoadingComplete={(image) => image.classList.remove('opacity-0')}
            className='transition-opacity opacity-0 duration-[2s]'
          />
          <div>
            <Image
              src={m5}
              alt='m5'
              onLoadingComplete={(image) => image.classList.remove('opacity-0')}
              className='transition-opacity opacity-0 duration-[2s]'
            />
            <Image
              src={m6}
              alt='m6'
              onLoadingComplete={(image) => image.classList.remove('opacity-0')}
              className='transition-opacity opacity-0 duration-[2s]'
            />
          </div>
        </div>

        <div>
          <Image
            src={m4}
            alt='m4'
            onLoadingComplete={(image) => image.classList.remove('opacity-0')}
            className='transition-opacity opacity-0 duration-[2s]'
          />
          <Image
            src={m7}
            alt='m7'
            onLoadingComplete={(image) => image.classList.remove('opacity-0')}
            className='transition-opacity opacity-0 duration-[2s]'
          />
        </div>
      </div>
    </div>
  );
};

export default EventHeroImage;
